'use client'

import Image from 'next/image'
import { useCallback, useState } from 'react'
import assetLoader from '@utils/internalImageLoader'
import { fuelStringSubstitution } from '@utils/fuelStringUtils'
import { MINUS, PLUS } from '../constants/text'
import styles from './fuelAccordian.module.scss'

const AccordianContent = ({
  location,
  fuelType,
  parsedLocationIsState,
  mappedStateWithCities,
  index,
  collapsible,
  modifiedContent,
  stateCode
}) => {
  const [active, setActive] = useState(0)

  const handleClick = useCallback(
    index => {
      if (index === active) {
        setActive(-1)
      } else {
        setActive(index)
      }
    },
    [active]
  )

  return (
    <div className={styles.fuelAccordionWrapper}>
      <div className={styles.accordianHeader} onClick={() => handleClick(index)}>
        <div className={styles.accordianTitle}>
          {fuelStringSubstitution(
            collapsible?.attributes?.title,
            fuelType,
            location,
            true,
            mappedStateWithCities,
            parsedLocationIsState,
            stateCode
          )}
        </div>
        <div className={styles.iconWrapper}>
          <Image
            height={14}
            width={14}
            src={
              active === index
                ? `${assetLoader()}/${MINUS}`
                : `${assetLoader()}/${PLUS}`
            }
            alt="Icon"
            loading="lazy"
            layout="fixed"
          />
        </div>
      </div>
      {active === index && (
        <div className={styles.accordianContentFuel} id={`pm-${index}`}>
          <span dangerouslySetInnerHTML={{ __html: modifiedContent }} />
        </div>
      )}
    </div>
  )
}

export default AccordianContent
